import React from "react";
import { useTranslation } from "react-i18next";
import DashboardHeader from "../../../../../components/dashboard/dashboardHeader";
import { ProjectCategoriesStackList } from "../../../../../components/dashboard/projects/categories/project-categories-stack-list";

export const ProjectCategoriesList = () => {
  const { t } = useTranslation();

  return (
    <>
      <DashboardHeader
        subtitle=""
        actions={[]}
        title="Project Categories"
        meta={[]}
      >
        <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
          <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
            <ProjectCategoriesStackList />
          </div>
        </div>
      </DashboardHeader>
    </>
  );
};
